// Web shim for @react-native-clipboard/clipboard

const Clipboard = {
  getString: async () => {
    try {
      return await navigator.clipboard.readText();
    } catch {
      return '';
    }
  },
  setString: (text) => {
    try {
      navigator.clipboard.writeText(text);
    } catch {
      // fallback
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  },
};

export default Clipboard;
